var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_crown_svg__clip0_21237_60106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.288 10.563c-3.44-.769-5.234-5.052-5.789-6.648v-.603l-.095.314c-.064-.199-.098-.313-.098-.313v.602c-.555 1.596-2.349 5.88-5.79 6.647-4.246.95-7.717-3.93-7.717-3.93l3.088 13.364h21.035L30.01 6.632s-3.475 4.88-7.718 3.93h-.004z",
    fill: "#E0C000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.009 2.464c0 1.361-1.123 2.464-2.509 2.464s-2.508-1.103-2.508-2.464C13.992 1.102 15.114 0 16.5 0s2.509 1.102 2.509 2.464zM5.017 6.347c0 1.361-1.123 2.464-2.509 2.464S0 7.708 0 6.347c0-1.362 1.122-2.464 2.508-2.464s2.509 1.102 2.509 2.464zM33 6.347c0 1.361-1.121 2.464-2.507 2.464-1.386 0-2.509-1.103-2.509-2.464 0-1.362 1.123-2.464 2.509-2.464S33 4.985 33 6.347z",
    fill: "#E0C000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_crown_svg__clip0_21237_60106"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h33v20H0z"
  })))));
}

export default SvgIconCrown;